import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import { getNumberComma } from '../../utils/numberUtils';

const TaxbillTotalSummary = ({ totalPrice }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="flex-end"
      spacing={2}
      sx={{ my: 2, px: 1 }}
      divider={<Divider orientation="vertical" flexItem />}
    >
      <Stack direction="row" spacing={1}>
        <Typography variant="body2">총 계산서 금액:</Typography>
        <Typography variant="subtitle2">
          {getNumberComma(totalPrice)}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default TaxbillTotalSummary;
